var _path, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodeOfConduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3451 26.9605L14.3356 26.9553L14.3259 26.9505C14.0186 26.7976 13.834 26.4865 13.834 26.0376C13.834 23.8501 15.659 22.0308 17.8639 22.0308H22.1374C24.3485 22.0308 26.1673 23.7712 26.1673 26.0376C26.1673 26.4389 25.9348 26.7906 25.6485 26.9648C24.9826 27.3299 23.3718 27.8335 20.0007 27.8335C16.6164 27.8335 15.0062 27.3259 14.3451 26.9605ZM23.6032 15.7484C23.6032 17.7241 21.9927 19.33 20.0007 19.33C18.0086 19.33 16.3981 17.7241 16.3981 15.7484C16.3981 13.7727 18.0086 12.1667 20.0007 12.1667C21.9927 12.1667 23.6032 13.7727 23.6032 15.7484Z",
    fill: "url(#paint0_linear_1528_18435)",
    stroke: "url(#paint1_linear_1528_18435)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white",
    fillOpacity: 0.07
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1528_18435",
    x1: 20.0007,
    y1: 11.6667,
    x2: 20.0007,
    y2: 28.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1528_18435",
    x1: 20.0007,
    y1: 11.6667,
    x2: 20.0007,
    y2: 28.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeOfConduct);
export default __webpack_public_path__ + "static/media/code_of_conduct.d2ae2c18659e8ada0d9010057c18cf7a.svg";
export { ForwardRef as ReactComponent };